// extracted by mini-css-extract-plugin
export default {"main":"modal_main__tXEZq","inside":"modal_inside__FXEbK","right":"modal_right__+obFj","top":"modal_top__PY2LT","close":"modal_close__if+Ad"};